import { render, staticRenderFns } from "./RecipeItemAssociationDelete.vue?vue&type=template&id=a511e294&"
import script from "./RecipeItemAssociationDelete.vue?vue&type=script&lang=js&"
export * from "./RecipeItemAssociationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports